<script setup>
import { onMounted, defineProps, defineEmits, ref, computed } from 'vue';
import i18n from '@/i18n';
import service from '@/service';
import util from '@/util';

const props = defineProps({ visible: Boolean });
const emit = defineEmits(['update:visible']);
const showDrawer = computed({
  get() {
    return props.visible;
  },
  set(val) {
    emit('update:visible', val);
  },
});

const lang = ref(i18n.locale);
const langList = ref([]);

onMounted(async () => {
  const res = await service.getLangList();
  langList.value = res.map(e => ({
    value: `${e.name}_${e.country}`,
    label: i18n.t(`lang.${e.name}_${e.country}`),
  }));
});

const changeLang = async newLang => {
  try {
    await service.changeLang(newLang);
  } finally {
    const params = util.changeURLSearchParam('lang', newLang);
    location.href = location.origin + location.pathname + params;
    i18n.locale = newLang;
  }
};
</script>

<template>
  <el-drawer :visible.sync="showDrawer" direction="rtl" size="80%" custom-class="rounded-l-2xl">
    <div class="flex justify-center">
      <el-select v-model="lang" @change="changeLang" class="w-4/5">
        <el-option
          v-for="item in langList"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
    </div>
  </el-drawer>
</template>

<style scoped>
:deep(.el-input__inner) {
  color: #191919;
  border-left: none;
  border-top: none;
  border-right: none;
  border-radius: 0;
  height: 48px;
}
</style>
